import { type ZodType, z } from "zod";

const BIRTH_NUMBER_PATTERN = /^\d{6}\/?\d{3,4}$/;

export const requiredBirthNumber = (
	requiredMessage: string,
	formatMessage: string,
): ZodType<string, z.ZodTypeDef, string> =>
	z
		.string()
		.trim()
		.min(1, requiredMessage)
		.regex(BIRTH_NUMBER_PATTERN, formatMessage);
